export enum GameSceneTag {
	OBSTICLE = "obsticle_scene_tag",
	CLOUD = "cloud_scene_tag",
	DRAGON = "dragon_scene_tag",
	ANCIENT_DRAGON = "ancient_dragon_scene_tag",
	GROUND = "ground_scene_tag",
	LEVEL = "level_scene_tag",
	GAME_CONFIG = "config_scene_tag",
	TO_DESTROY = "to_destroy_scene_tag",
}
